<template>
    <div class="selected-filter-row">
        <div class="uk-flex-inline uk-flex-wrap uk-card uk-card-default uk-card-small uk-card-body" style="padding: 10px;">
            <h3 class="uk-card-title">{{ property.name }}: </h3>
            <div v-for="propertyValue in propertyValues" :key="propertyValue.id" class="uk-flex uk-flex-center uk-flex-bottom">
                <label> {{ propertyValue.value_varchar }} <input v-model="checkedPropertyValues" @change="reset" :value="propertyValue.id"
                                                               class="uk-checkbox uk-margin-xsmall-right"
                                                               style="margin-top: 0;"
                                                               type="checkbox">
                </label>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SelectedShopFilterRow",
        props: {
            property: {
                type: Object,
                required: true,
            },
            propertyValues: {
                type: Array,
                required: true,
            },
            selected: {
                type: Array,
                default() {
                    return []
                }
            }
        },
        computed: {
            hasNotSelected() {
                return this.checkedPropertyValues.length !== this.propertyValues.length
            },
            moreThanOne() {
                return this.propertyValues.length > 1
            }
        },
        data() {
            return {
                checkedPropertyValues: this.selected
            }
        },
        methods: {
            reset() {
                this.$emit('filter-changed', this.property.id, this.checkedPropertyValues)
            },

        }
    }
</script>

<style scoped>
    .tm-disabled {
        color: #999;
    }
</style>



// WEBPACK FOOTER //
// SelectedShopFilterRow.vue?79e00c9a